"use strict";
// tslint:disable:only-arrow-functions
;
(function () {
    if (typeof Element !== 'undefined' && !Element.prototype.addEventListener) {
        var eventListeners_1 = [];
        var addEventListener_1 = function (type, listener /* useCapture (will be ignored) */) {
            var self = this;
            var wrapper = function (e) {
                // @ts-expect-error
                e.target = e.srcElement;
                // @ts-expect-error
                e.currentTarget = self;
                if (typeof listener.handleEvent !== 'undefined') {
                    ;
                    listener.handleEvent(e);
                }
                else {
                    ;
                    listener.call(self, e);
                }
            };
            if (type === 'DOMContentLoaded') {
                var wrapper2 = function (e) {
                    if (document.readyState === 'complete') {
                        wrapper(e);
                    }
                };
                // @ts-expect-error
                document.attachEvent('onreadystatechange', wrapper2);
                eventListeners_1.push({
                    // @ts-expect-error
                    object: this,
                    type: type,
                    listener: listener,
                    wrapper: wrapper2,
                });
                if (document.readyState === 'complete') {
                    // @ts-expect-error
                    var e = new Event();
                    // @ts-expect-error
                    e.srcElement = window;
                    wrapper2(e);
                }
            }
            else {
                // @ts-expect-error
                this.attachEvent('on' + type, wrapper);
                eventListeners_1.push({
                    // @ts-expect-error
                    object: this,
                    type: type,
                    listener: listener,
                    wrapper: wrapper,
                });
            }
        };
        var removeEventListener_1 = function (type, listener /* useCapture (will be ignored) */) {
            var counter = 0;
            while (counter < eventListeners_1.length) {
                var eventListener = eventListeners_1[counter];
                if (
                // @ts-expect-error
                eventListener.object === this &&
                    eventListener.type === type &&
                    eventListener.listener === listener) {
                    if (type === 'DOMContentLoaded') {
                        // @ts-expect-error
                        this.detachEvent('onreadystatechange', eventListener.wrapper);
                    }
                    else {
                        // @ts-expect-error
                        this.detachEvent('on' + type, eventListener.wrapper);
                    }
                    eventListeners_1.splice(counter, 1);
                    break;
                }
                ++counter;
            }
        };
        Element.prototype.addEventListener = addEventListener_1;
        Element.prototype.removeEventListener = removeEventListener_1;
        if (HTMLDocument && !HTMLDocument.prototype.addEventListener) {
            HTMLDocument.prototype.addEventListener = addEventListener_1;
            HTMLDocument.prototype.removeEventListener = removeEventListener_1;
        }
        if (Window && !Window.prototype.addEventListener) {
            Window.prototype.addEventListener = addEventListener_1;
            Window.prototype.removeEventListener = removeEventListener_1;
        }
    }
})();
//# sourceMappingURL=add-event-listener.js.map